import React from 'react'
import StyledBgContainer from './StyledBgContainer/StyledBgContainer'
import { useNavigate } from 'react-router-dom'
import StyledButton from './Button/Button'
import Path from '../router/localRoutes'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <StyledBgContainer>
      <div className="container-fluid bottom-0 top-0 flex h-screen items-center justify-center overflow-auto">
        <div>
          <div className="mb-4 text-7xl tracking-wide font-bold lg:text-9xl text-primary-600 dark:text-primary-500">
            404
          </div>
          <div className="font-normal text-white m-10 py-5 text-[16px]">
            Sorry but we could not find the page you are looking for
          </div>
          <StyledButton
            className="h-10 bg-Purple-700 text-2 font-inter-3"
            onClick={() => navigate(Path.Root)}
          >
            Go Home
          </StyledButton>
        </div>
      </div>
    </StyledBgContainer>
  )
}

export default NotFound
